// Services/DecisionBoard.ts (or .js if JS)
// Define the structure for the atom so selector can safely access its fields
import { atom } from 'recoil';

const InvoiceProposalsAtom = atom({
  key: 'InvoiceProposalsKey',
  default: {
    filters: {
      to: '',
      include_assigned_by: false,
      fetch_all: false,
      page: 0,
      search: '',
      limit: 10, 
    },
    cache: {},
    totalCountCache: {},
  },
});

export { InvoiceProposalsAtom };
